import { render, staticRenderFns } from "./ReadyShipment.vue?vue&type=template&id=2dcc5df9&scoped=true"
import script from "./ReadyShipment.vue?vue&type=script&lang=js"
export * from "./ReadyShipment.vue?vue&type=script&lang=js"
import style0 from "./ReadyShipment.vue?vue&type=style&index=0&id=2dcc5df9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dcc5df9",
  null
  
)

export default component.exports